import { NextPage, NextPageContext } from "next";
import { ErrorProps } from "next/error";
import Head from "next/head";
import * as React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";
import enMessages from "shared/lang/en.json";

import DefaultErrorPage from "@components/Errors/DefaultErrorPage";

import { pageDataLayer } from "@lib/dataLayers";

interface ICustomErrorPage extends ErrorProps {
  isBrowserError: boolean;
  err: Error;
}

const CustomErrorPage: NextPage<ICustomErrorPage> = ({
  statusCode,
  isBrowserError,
}) => {
  const texts = isBrowserError
    ? {
        pageTitle: enMessages["ErrorPage.browser-error.pageTitle"],
        heading: enMessages["ErrorPage.browser-error.heading"],
        description: enMessages["ErrorPage.browser-error.description"],
      }
    : {
        pageTitle: enMessages[`ErrorPage.http.${statusCode}.pageTitle`],
        heading: enMessages[`ErrorPage.http.${statusCode}.heading`],
        description: enMessages[`ErrorPage.http.${statusCode}.description`],
      };
  const { user } = useSelector((state: AppState) => {
    return { user: state.user };
  });

  useEffect(() => {
    pageDataLayer("other", user);
  }, [user]);

  return (
    <>
      <Head>
        <title>{isBrowserError ? "Error" : `Error - ${statusCode}`}</title>
      </Head>
      <DefaultErrorPage
        className={isBrowserError ? "-browser-error" : `-${statusCode}`}
        texts={texts}
      />
    </>
  );
};

CustomErrorPage.getInitialProps = ({
  res,
  err,
}: NextPageContext): ICustomErrorPage => {
  const isBrowserError = typeof res === "undefined";
  const statusCode =
    res && res.statusCode ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode, isBrowserError, err };
};

export default CustomErrorPage;
